import { randomInt } from './randomInt';

/**
 * Generates a random letter (a-z).
 * @returns {string} A random lowercase letter
 * @example
 * randomLetter() // returns a random letter between 'a' and 'z'
 */
export const randomLetter = (): string => randomInt(10, 35).toString(36);
